import classNames from 'classnames';

export interface IFormGroupProps {
  title: string;
  description?: string | undefined;
  isOptional?: boolean | undefined;
  addColon?: boolean | undefined;

  children: React.ReactNode | React.ReactNode[] | string;
}

export function FormGroup(props: IFormGroupProps) {
  return (
    <div className="gap-x-8 gap-y-4 pb-12 space-y-2">
      <div className="select-none">
        <h2 className="text-lg leading-7 text-brand-cashmere-900 md:col-span-2">
          {props.title}
          {props.addColon === true ? ':' : ''}

          {props.isOptional && (
            <span className="text-brand-cashmere-800 text-sm ms-2">
              (optional)
            </span>
          )}
        </h2>

        {props.description && (
          <p className="mt-1 text-sm leading-6 text-brand-cashmere-800">
            {props.description}
          </p>
        )}
      </div>

      <div className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-6 w-full">
        {props.children}
      </div>
    </div>
  );
}

export default FormGroup;
